import React from "react";
import asset from "../utils/assetUrl";

const MX_FLAG = '<img style="width: 25px" src="https://emojigraph.org/media/apple/flag-mexico_1f1f2-1f1fd.png" alt="México" />';
const CO_FLAG = '<img style="width: 25px" src="https://emojigraph.org/media/apple/flag-colombia_1f1e8-1f1f4.png" alt="Colombia" />';

const mapsSearch = (query) =>
    `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;

const locations = [
    // --- Próximas fechas: México, octubre 2026 ---
    {
        title: "Ciudad de México",
        icon: MX_FLAG,
        status: "proximo",
        dates: "Martes 06 de Octubre, 2026",
        venue: "Hotel Le Méridien",
        address: "Av. Paseo de la Reforma 69, Tabacalera, Cuauhtémoc",
        times: "4:00 pm - 9:00 pm",
        image: "/assets/images/cdmx.jpg",
        getthere: mapsSearch("Le Meridien Mexico City, Paseo de la Reforma 69, Tabacalera, Cuauhtemoc, Ciudad de Mexico")
    },
    {
        title: "Guadalajara",
        icon: MX_FLAG,
        status: "proximo",
        dates: "Jueves 08 de Octubre, 2026",
        venue: "Hotel Guadalajara Plaza Expo",
        address: "Av. Mariano Otero 3261, Verde Valle",
        times: "4:00 pm - 9:00 pm",
        image: "/assets/images/guadalajara.jpg",
        getthere: mapsSearch("Hotel Guadalajara Plaza Expo, Av. Mariano Otero 3261, Verde Valle, Guadalajara, Jalisco")
    },
    {
        title: "Monterrey",
        icon: MX_FLAG,
        status: "proximo",
        dates: "Sábado 10 de Octubre, 2026",
        // Direccion oficial del hotel, confirmada por el cliente el 14/08/2026.
        venue: "Hotel Antaris Cintermex",
        address: "Av. Fundidora 500, Col. Obrera, C.P. 64010",
        times: "9:00 am - 2:00 pm",
        image: "/assets/images/monterrey.jpg",
        getthere: mapsSearch("Hotel Antaris Cintermex, Av. Fundidora 500, Col. Obrera, Monterrey, Nuevo Leon")
    },

    // --- Ediciones anteriores: Colombia, febrero-marzo 2026 ---
    {
        title: "Bogotá",
        icon: CO_FLAG,
        status: "realizado",
        dates: "Sábado 28 de Febrero, 2026",
        venue: "Torre Banco Falabella",
        address: "Av Carrera 19 #120-71",
        times: "9:00 am - 1:00 pm",
        image: "/assets/images/bogota.jpg",
        getthere: "https://www.google.com/maps/dir//Banco+Falabella,+Cra+19+%23120-71,+Bogot%C3%A1/@4.7013444,-74.0502697,19.47z/data=!4m9!4m8!1m0!1m5!1m1!1s0x8e3f9ab4252bb5d9:0x944a9ae9c7a15bb4!2m2!1d-74.0496592!2d4.7016126!3e0?entry=ttu&g_ep=EgoyMDI1MDkxNi4wIKXMDSoASAFQAw%3D%3D"
    },
    {
        title: "Cali",
        icon: CO_FLAG,
        status: "realizado",
        dates: "Martes 03 de Marzo, 2026",
        venue: "Hilton Garden Inn Cali",
        address: "Calle 15a # 100-21",
        times: "5:00pm - 8:00pm",
        image: "/assets/images/cali-v2.jpg",
        getthere: "https://www.google.com/maps/dir//Hilton+Garden+Inn+Cali+Ciudad+Jardin,+Calle+15+A+%23100+21,+Ciudad+Jard%C3%ADn,+Cali,+Valle+del+Cauca/@3.3675689,-76.5335598,1133m/data=!3m1!1e3!4m20!1m10!3m9!1s0x8e30a1be2dcf2329:0x3de5085900f6f660!2sHilton+Garden+Inn+Cali+Ciudad+Jardin!5m2!4m1!1i2!8m2!3d3.3675635!4d-76.5309849!16s%2Fg%2F11mn0g1zv5!4m8!1m0!1m5!1m1!1s0x8e30a1be2dcf2329:0x3de5085900f6f660!2m2!1d-76.5309849!2d3.3675635!3e3?entry=ttu&g_ep=EgoyMDI2MDEyNi4wIKXMDSoASAFQAw%3D%3D"
    },
    {
        title: "Bucaramanga",
        icon: CO_FLAG,
        status: "realizado",
        dates: "Jueves 05 de Marzo, 2026",
        venue: "Hotel Bari Bucaramanga",
        address: "Carrera 38 # 48 - 66",
        times: "4:00pm - 8:00pm",
        image: "/assets/images/bga-2.jpg",
        getthere: "https://www.google.com/maps/dir//Hotel+Bari+Bucaramanga,+Cra.+38+%234866,+Cabecera+del+llano,+Bucaramanga,+Santander/@5.8860158,-74.8734915,8z/data=!4m8!4m7!1m0!1m5!1m1!1s0x8e683fe1204696d9:0xd0cd55bbd8654d4d!2m2!1d-73.1083434!2d7.1164659?entry=ttu&g_ep=EgoyMDI2MDEyNi4wIKXMDSoASAFQAw%3D%3D"
    },
    {
        title: "Medellín",
        icon: CO_FLAG,
        status: "realizado",
        dates: "Sábado 07 de Marzo, 2026",
        venue: "Coworking Home Tree",
        address: "Calle 33A #70A - 44, Laureles",
        times: "10:00 am - 2:00 pm",
        image: "/assets/images/mde-2.jpg",
        getthere: "https://www.google.com/maps/dir//Coworking+Home+Tree,+Cl.+33A+%2370a-44,+Laureles+-+Estadio,+Medell%C3%ADn,+Laureles,+Medell%C3%ADn,+Antioquia/@4.6581122,-74.1357403,4523m/data=!3m1!1e3!4m8!4m7!1m0!1m5!1m1!1s0x8e4429001a89e441:0xca801c6bb223c2a4!2m2!1d-75.5918625!2d6.2397905?entry=ttu&g_ep=EgoyMDI2MDEyNi4wIKXMDSoASAFQAw%3D%3D"
    },
    {
        title: "Cartagena",
        icon: CO_FLAG,
        status: "realizado",
        dates: "Martes 10 de Marzo, 2026",
        venue: "Hotel Stil Cartagena",
        address: "Calle 34 # 11-15 Plazoleta Telecom",
        times: "5:00pm - 8:00pm",
        image: "/assets/images/ctg-2.jpg",
        getthere: "https://www.google.com/maps/dir//Hotel+Stil+Cartagena,+Plazoleta+Benkos+Bioh%C3%B3+Centro,+La+Matuna,+Cartagena+de+Indias,+Cartagena,+Cartagena+de+Indias,+Bol%C3%ADvar/@7.8254252,-77.1937335,1150947m/data=!3m1!1e3!4m8!4m7!1m0!1m5!1m1!1s0x8ef62f9e82ed5985:0x5113863d0d3c1a3a!2m2!1d-75.5453809!2d10.4251889?entry=ttu&g_ep=EgoyMDI2MDEyNi4wIKXMDSoASAFQAw%3D%3D"
    }
];

// status: "proximo" para las fechas abiertas, "realizado" para el histórico.
const Locations = ({ status = "proximo" }) => {
    const visible = locations.filter((location) => location.status === status);

    return (
        <>
            {visible.map((location, index) => (
                <div className={`location-item ${location.status}`} key={index}>

                    <figure
                        className="nostatic relative"
                        style={{ backgroundImage: `url(${asset(location.image)})` }}
                    >
                        <span
                            className="icon"
                            dangerouslySetInnerHTML={{ __html: location.icon }}
                        />
                    </figure>
                    <h4 dangerouslySetInnerHTML={{ __html: location.title }}></h4>


                    <div className="dates">
                        <div className="date-time">
                            <p className="date">{location.dates}</p>
                            <p className="time">{location.times}</p>
                        </div>
                    </div>
                    <div className="directions">
                        <p>{location.venue}</p>
                        <a target="_blank" rel="noreferrer" title="Como llegar" href={location.getthere}>
                            <p>{location.address}</p>
                        </a>
                    </div>
                </div>
            ))}
        </>
    );
};

export default Locations;
